;

const ResetPasswordIcon: React.FC<{ color?: string }> = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
		<path
			fill={color || "#367BF5"}
			d="M4 12c0-2.33 1.02-4.42 2.62-5.88L9 8.5v-6H3l2.2 2.2C3.24 6.52 2 9.11 2 12c0 5.19 3.95 9.45 9 9.95v-2.02c-3.94-.49-7-3.86-7-7.93zm18 0c0-5.19-3.95-9.45-9-9.95v2.02c3.94.49 7 3.86 7 7.93 0 2.33-1.02 4.42-2.62 5.88L15 15.5v6h6l-2.2-2.2c1.96-1.82 3.2-4.41 3.2-7.3z"
		/>
		<path
			fill={color || "#367BF5"}
			d="M14.143 10.2V9c0-1.104-.96-2-2.143-2-1.183 0-2.143.896-2.143 2v1.2c-.471 0-.857.36-.857.8v3.2c0 .44.386.8.857.8h4.286c.471 0 .857-.36.857-.8V11c0-.44-.386-.8-.857-.8zm-.857 0h-2.572V9c0-.664.575-1.2 1.286-1.2.711 0 1.286.536 1.286 1.2v1.2z"
		/>
	</svg>
);

export default ResetPasswordIcon;
